var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Account = (function (Account) {

        Account.Messages = (function (Messages) {

            Messages.GetUserAccount = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserAccount', data);
            };
            Messages.GetUserAccount.className = 'Vendd.Account.Messages.GetUserAccount';

            Messages.GetUserAccountFailure = function (response) {
                var data = {
                    response: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserAccountFailure', data);
            };
            Messages.GetUserAccountFailure.className = 'Vendd.Account.Messages.GetUserAccountFailure';

            Messages.GetUserAccountSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserAccountSuccess', data);
            };
            Messages.GetUserAccountSuccess.className = 'Vendd.Account.Messages.GetUserAccountSuccess';

            Messages.EditUser = function (firstName, lastName, userName, email, oldPassword, password, passwordConfirmation, newsletter, phones, mobilePhone, socialSecurityNumber, birthDate, isLoyaltyMember, loyaltyRequest, receiveEinvoice, loyaltyMemberId, resellerDisplayedPrice, loyaltyMemberCardNumber, sfmRegistrationRequest) {
                var data = {
                    firstName: firstName,
                    lastName: lastName,
                    userName: userName,
                    email: email,
                    oldPassword: oldPassword,
                    password: password,
                    passwordConfirmation: passwordConfirmation,
                    newsletter: newsletter,
                    phones: phones,
                    mobilephone: mobilePhone,
                    socialSecurityNumber: socialSecurityNumber,
                    birthDate: birthDate,
                    IsLoyaltyMember: isLoyaltyMember,
                    LoyaltyRequest: loyaltyRequest,
                    ReceiveEinvoice: receiveEinvoice,
                    LoyaltyMemberId: loyaltyMemberId,
                    ResellerDisplayedPrice: resellerDisplayedPrice,
                    loyaltyMemberCardNumber: loyaltyMemberCardNumber,
                    sfmRegistrationRequest: sfmRegistrationRequest
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditUser', data);
            };
            Messages.EditUser.className = 'Vendd.Account.Messages.EditUser';

            Messages.EditUserSuccess = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Account.Messages.EditUserSuccess", response);
            };
            Messages.EditUserSuccess.className = 'Vendd.Account.Messages.EditUserSuccess';

            Messages.EditUserFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Account.Messages.EditUserFailed", response);
            };
            Messages.EditUserFailed.className = "Vendd.Account.Messages.EditUserFailed";

            Messages.GetAddresses = function (addressType, addressGroupFilter) {
                var data = {
                    addressType: addressType,
                    addressGroupFilter: addressGroupFilter
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddresses', data);
            };
            Messages.GetAddresses.className = "Vendd.Account.Messages.GetAddresses";

            Messages.GetAddressesSuccess = function (model) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressesSuccess', model);
            };
            Messages.GetAddressesSuccess.className = 'Vendd.Account.Messages.GetAddressesSuccess';

            Messages.GetAddressesFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressesFailed', response);
            };
            Messages.GetAddressesFailed.className = 'Vendd.Account.Messages.GetAddressesFailed';

            Messages.SetDefaultAddress = function (addressId, addressType) {
                var data = {
                    addressId: addressId,
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SetDefaultAddress', data);
            };
            Messages.SetDefaultAddress.className = 'Vendd.Account.Messages.SetDefaultAddress';

            Messages.SetDefaultAddressSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SetDefaultAddressSuccess', data);
            };
            Messages.SetDefaultAddressSuccess.className = 'Vendd.Account.SetDefaultAddressSuccess';

            Messages.SetDefaultAddressFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SetDefaultAddressFailure', data);
            };
            Messages.SetDefaultAddressFailure.className = 'Vendd.Account.Messages.SetDefaultAddressFailure';

            Messages.DeleteAddress = function (addressId, addressType) {
                var data = {
                    addressId: addressId,
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddress', data);
            };
            Messages.DeleteAddress.className = 'Vendd.Account.Messages.DeleteAddress';

            Messages.DeleteAddressSuccess = function (adressId) {
                var data = {
                    adressId: adressId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressSuccess', adressId);
            };
            Messages.DeleteAddressSuccess.className = 'Vendd.Account.Messages.DeleteAddressSuccess';

            Messages.DeleteAddressFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressFailure', data);
            };
            Messages.DeleteAddressFailure.className = 'Vendd.Account.Messages.DeleteAddressFailure';

            Messages.EditAddress = function (addressType, Id, title, firstName, lastName, phone, mobile, fax, addressLine1, addressLine2, streetnumber, apartment, bell, entrance, floor, block, postCode, area,
                city, prefecture, country, companyName, headquarters, occupation, taxAgency, taxAgencyId, taxIdentifier, vatStatus, receiveEinvoice, isInvoice, addressGroupId) {
                var data = {
                    model: {
                        Id: Id,
                        Title: title,
                        FirstName: firstName,
                        LastName: lastName,
                        Phones: phone,
                        Mobiles: mobile,
                        Fax: fax,
                        AddressLine1: addressLine1,
                        AddressLine2: addressLine2,
                        Streetnumber: streetnumber,
                        Apartment: apartment,
                        Bell: bell,
                        Entrance: entrance,
                        Floor: floor,
                        Block: block,
                        PostCode: postCode,
                        Area: area,
                        City: city,
                        Prefecture: prefecture,
                        Country: country,
                        CompanyName: companyName,
                        Headquarters: headquarters,
                        Occupation: occupation,
                        TaxAgency: taxAgency,
                        TaxAgencyId: taxAgencyId,
                        TaxIdentifier: taxIdentifier,
                        VatStatus: vatStatus,
                        ReceiveEinvoice: receiveEinvoice,
                        IsInvoice: isInvoice,
                        GroupId: addressGroupId
                    },
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddress', data, addressType);
            };
            Messages.EditAddress.className = 'Vendd.Account.Messages.EditAddress';

            Messages.EditAddressSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressSuccess', data);
            };
            Messages.EditAddressSuccess.className = 'Vendd.Account.Messages.EditAddressSuccess';

            Messages.EditAddressFailed = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressFailed', data);
            };
            Messages.EditAddressFailed.className = 'Vendd.Account.Messages.EditAddressFailed';

            Messages.CheckAddressIfExists = function (addressId, firstName, lastName, addressLine1, addressLine2, city, postCode, country, area, isBillingAddress, isShippingAddress) {
                var data = {
                    addressId: addressId,
                    firstName: firstName,
                    lastName: lastName,
                    addressLine1: addressLine1,
                    addressLine2: addressLine2,
                    city: city,
                    postCode: postCode,
                    country: country,
                    area: area,
                    isBillingAddress: isBillingAddress,
                    isShippingAddress: isShippingAddress
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressIfExists', data);
            };
            Messages.CheckAddressIfExists.className = 'Vendd.Account.Messages.CheckAddressIfExists';

            Messages.CheckAddressIfExistsSuccess = function (response) {
                var data = {
                    response: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressIfExistsSuccess', response);
            };
            Messages.CheckAddressIfExistsSuccess.className = 'Vendd.Account.Messages.CheckAddressIfExistsSuccess';

            Messages.CheckAddressIfExistsFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressIfExistsFailure', data);
            };
            Messages.CheckAddressIfExistsFailure.className = 'Vendd.Account.Messages.CheckAddressIfExistsFailure';

            Messages.OpenAddressEditForm = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.OpenAddressEditForm', data);
            };
            Messages.OpenAddressEditForm.className = 'Vendd.Account.Messages.OpenAddressEditForm';

            Messages.GetAreasForPostCode = function (country, postCode, area) {
                var data = {
                    country: country,
                    postCode: postCode,
                    area: area
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasForPostCode', data);
            };
            Messages.GetAreasForPostCode.className = 'Vendd.Account.Messages.GetAreasForPostCode';

            Messages.GetAreasForPostCodeSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasForPostCodeSuccess', data);
            };
            Messages.GetAreasForPostCodeSuccess.className = 'Vendd.Account.Messages.GetAreasForPostCodeSuccess';

            Messages.GetAreasForPostCodeFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasForPostCodeFailed', response);
            };
            Messages.GetAreasForPostCodeFailed.className = 'Vendd.Account.Messages.GetAreasForPostCodeFailed';

            Messages.GetCountries = function (model, addressType) {
                var data = {
                    selectedCountryCode: model.Country,
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCountries', data);
            };
            Messages.GetCountries.className = 'Vendd.Account.Messages.GetCountries';

            Messages.GetCountriesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCountriesSuccess', data);
            };
            Messages.GetCountriesSuccess.className = 'Vendd.Account.Messages.GetCountriesSuccess';

            Messages.GetCountriesFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCountriesFailed', response);
            };
            Messages.GetCountriesFailed.className = 'Vendd.Account.Messages.GetCountriesFailed';

            Messages.GetPrefecture = function (countryCode, area, postCode) {
                var data = {
                    postCode: postCode,
                    area: area,
                    countryCode: countryCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefecture', data);
            };
            Messages.GetPrefecture.className = 'Vendd.Account.Messages.GetPrefecture';

            Messages.GetPrefectureSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefectureSuccess', data);
            };
            Messages.GetPrefectureSuccess.className = 'Vendd.Account.Messages.GetPrefectureSuccess';

            Messages.GetPrefectureFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefectureFailed', response);
            };
            Messages.GetPrefectureFailed.className = 'Vendd.Account.Messages.GetPrefectureFailed';

            Messages.GetPrefectures = function (countryCode, addressType) {
                var data = {
                    languageCode: LhApp.Context.Language,
                    addressType: addressType,
                    countryCode: countryCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefectures', data);
            };
            Messages.GetPrefectures.className = 'Vendd.Account.Messages.GetPrefectures';

            Messages.GetPrefecturesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefecturesSuccess', data);
            };
            Messages.GetPrefecturesSuccess.className = 'Vendd.Account.Messages.GetPrefecturesSuccess';

            Messages.GetPrefecturesFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefecturesFailed', response);
            };
            Messages.GetPrefecturesFailed.className = 'Vendd.Account.Messages.GetPrefecturesFailed';

            Messages.GetCities = function (countryCode, prefectureName, addressType) {
                var data = {
                    languageCode: LhApp.Context.Language,
                    addressType: addressType,
                    countryCode: countryCode,
                    prefectureName: prefectureName
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCities', data);
            };
            Messages.GetCities.className = 'Vendd.Account.Messages.GetCities';

            Messages.GetCitiesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCitiesSuccess', data);
            };
            Messages.GetCitiesSuccess.className = 'Vendd.Account.Messages.GetCitiesSuccess';

            Messages.GetCitiesFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCitiesFailed', response);
            };
            Messages.GetCitiesFailed.className = 'Vendd.Account.Messages.GetCitiesFailed';

            Messages.GetAreas = function (countryCode, prefectureName, cityName, addressType) {
                var data = {
                    languageCode: LhApp.Context.Language,
                    addressType: addressType,
                    countryCode: countryCode,
                    prefectureName: prefectureName,
                    cityName: cityName
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreas', data);
            };
            Messages.GetAreas.className = 'Vendd.Account.Messages.GetAreas';

            Messages.GetAreasSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasSuccess', data);
            };
            Messages.GetAreasSuccess.className = 'Vendd.Account.Messages.GetAreasSuccess';

            Messages.GetAreasFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasFailed', response);
            };
            Messages.GetAreasFailed.className = 'Vendd.Account.Messages.GetAreasFailed';

            Messages.GetPostCodes = function (countryCode, prefectureName, cityName, areaName, searchText, addressType) {
                var data = {
                    languageCode: LhApp.Context.Language,
                    addressType: addressType,
                    countryCode: countryCode,
                    prefectureName: prefectureName,
                    cityName: cityName,
                    areaName: areaName,
                    searchText: searchText
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPostCodes', data);
            };
            Messages.GetPostCodes.className = 'Vendd.Account.Messages.GetPostCodes';

            Messages.GetPostCodesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPostCodesSuccess', data);
            };
            Messages.GetPostCodesSuccess.className = 'Vendd.Account.Messages.GetPostCodesSuccess';

            Messages.GetPostCodesFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPostCodesFailed', response);
            };
            Messages.GetPostCodesFailed.className = 'Vendd.Account.Messages.GetPostCodesFailed';

            Messages.GetStreets = function (countryCode, prefectureName, cityName, areaName, searchText, addressType) {
                var data = {
                    languageCode: LhApp.Context.Language,
                    addressType: addressType,
                    countryCode: countryCode,
                    prefectureName: prefectureName,
                    cityName: cityName,
                    areaName: areaName,
                    searchText: searchText
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetStreets', data);
            };
            Messages.GetStreets.className = 'Vendd.Account.Messages.GetStreets';

            Messages.GetStreetsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetStreetsSuccess', data);
            };
            Messages.GetStreetsSuccess.className = 'Vendd.Account.Messages.GetStreetsSuccess';

            Messages.GetStreetsFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetStreetsFailed', response);
            };
            Messages.GetStreetsFailed.className = 'Vendd.Account.Messages.GetStreetsFailed';

            Messages.GetAllTaxAgencies = function (countryCode) {
                var data = {
                    countryCode: countryCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllTaxAgencies', data);
            };
            Messages.GetAllTaxAgencies.className = 'Vendd.Account.Messages.GetAllTaxAgencies';

            Messages.GetAllTaxAgenciesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllTaxAgenciesSuccess', data);
            };
            Messages.GetAllTaxAgenciesSuccess.className = 'Vendd.Account.Messages.GetAllTaxAgenciesSuccess';

            Messages.GetAllTaxAgenciesFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllTaxAgenciesFailed', response);
            };
            Messages.GetAllTaxAgenciesFailed.className = 'Vendd.Account.Messages.GetAllTaxAgenciesFailed';

            Messages.GetAllVatStatuses = function (model) {
                var data = {};
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllVatStatuses', data);
            };
            Messages.GetAllVatStatuses.className = 'Vendd.Account.Messages.GetAllVatStatuses';

            Messages.GetAllVatStatusesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllVatStatusesSuccess', data);
            };
            Messages.GetAllVatStatusesSuccess.className = 'Vendd.Account.Messages.GetAllVatStatusesSuccess';

            Messages.GetAllVatStatusesFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllVatStatusesFailed', response);
            };
            Messages.GetAllVatStatusesFailed.className = 'Vendd.Account.Messages.GetAllVatStatusesFailed';

            Messages.GetVatInfo = function (country, vat) {
                var data = {
                    country: country,
                    vat: vat
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetVatInfo', data);
            };
            Messages.GetVatInfo.className = 'Vendd.Account.Messages.GetVatInfo';

            Messages.GetVatInfoSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetVatInfoSuccess', data);
            };
            Messages.GetVatInfoSuccess.className = 'Vendd.Account.Messages.GetVatInfoSuccess';

            Messages.GetVatInfoFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetVatInfoFailed', response);
            };
            Messages.GetVatInfoFailed.className = 'Vendd.Account.Messages.GetVatInfoFailed';

            Messages.UniqueTaxIdentifierExists = function (countryCode, vatNumber) {
                var data = {
                    countryCode: countryCode,
                    vatNumber: vatNumber
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.UniqueTaxIdentifierExists', data);
            };
            Messages.UniqueTaxIdentifierExists.className = 'Vendd.Account.Messages.UniqueTaxIdentifierExists';

            Messages.UniqueTaxIdentifierExistsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.UniqueTaxIdentifierExistsSuccess', data);
            };
            Messages.UniqueTaxIdentifierExistsSuccess.className = 'Vendd.Account.Messages.UniqueTaxIdentifierExistsSuccess';

            Messages.UniqueTaxIdentifierExistsFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.UniqueTaxIdentifierExistsFailed', response);
            };
            Messages.UniqueTaxIdentifierExistsFailed.className = 'Vendd.Account.Messages.UniqueTaxIdentifierExistsFailed';

            Messages.GetAllAddressGroups = function (selectedAddressGroupId) {
                var data = {
                    selectedAddressGroupId: selectedAddressGroupId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllAddressGroups', data);
            };
            Messages.GetAllAddressGroups.className = 'Vendd.Account.Messages.GetAllAddressGroups';

            Messages.GetAllAddressGroupsSuccess = function (response) {
                var data = {
                    model: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllAddressGroupsSuccess', data);
            };
            Messages.GetAllAddressGroupsSuccess.className = 'Vendd.Account.Messages.GetAllAddressGroupsSuccess';

            Messages.GetAllAddressGroupsFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllAddressGroupsFailed', response);
            };
            Messages.GetAllAddressGroupsFailed.className = 'Vendd.Account.Messages.GetAllAddressGroupsFailed';

            Messages.AddressModelChanged = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.AddressModelChanged', response);
            };
            Messages.AddressModelChanged.className = 'Vendd.Account.Messages.AddressModelChanged';

            Messages.ConvertPointsToCoupons = function (accountId) {
                var data = {
                    accountId: accountId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ConvertPointsToCoupons', data);
            };
            Messages.ConvertPointsToCoupons.className = 'Vendd.Account.Messages.ConvertPointsToCoupons';

            Messages.ConvertPointsToCouponsFailure = function (response) {
                var data = {
                    response: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ConvertPointsToCouponsFailure', response);
            };
            Messages.ConvertPointsToCouponsFailure.className = 'Vendd.Account.Messages.ConvertPointsToCouponsFailure';

            Messages.ConvertPointsToCouponsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ConvertPointsToCouponsSuccess', data);
            };
            Messages.ConvertPointsToCouponsSuccess.className = 'Vendd.Account.Messages.ConvertPointsToCouponsSuccess';

            Messages.RequestToDeleteUser = function (model) {
                var data = { reason : model.Reason };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToDeleteUser', data);
            };
            Messages.RequestToDeleteUser.className = 'Vendd.Account.Messages.RequestToDeleteUser';

            Messages.RequestToDeleteUserSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToDeleteUserSuccess', data);
            };
            Messages.RequestToDeleteUserSuccess.className = 'Vendd.Account.Messages.RequestToDeleteUserSuccess';

            Messages.RequestToDeleteUserFailed = function(response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToDeleteUserFailed', response);
            };
            Messages.RequestToDeleteUserFailed.className = 'Vendd.Account.Messages.RequestToDeleteUserFailed';

            Messages.RequestToExportData = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToExportData');
            };
            Messages.RequestToExportData.className = 'Vendd.Account.Messages.RequestToExportData';

            Messages.RequestToExportDataSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToExportDataSuccess', data);
            };
            Messages.RequestToExportDataSuccess.className = 'Vendd.Account.Messages.RequestToExportDataSuccess';

            Messages.RequestToExportDataFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToExportDataFailed', response);
            };
            Messages.RequestToExportDataFailed.className = 'Vendd.Account.Messages.RequestToExportDataFailed';

            Messages.GetCouponInformations = function (model) {
                var data = { couponCode: model.couponCode };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCouponInformations', data);
            };
            Messages.GetCouponInformations.className = 'Vendd.Account.Messages.GetCouponInformations';

            Messages.GetCouponInformationsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCouponInformationsSuccess', data);
            };
            Messages.GetCouponInformationsSuccess.className = 'Vendd.Account.Messages.GetCouponInformationsSuccess';

            Messages.GetCouponInformationsFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCouponInformationsFailed', response);
            };
            Messages.GetCouponInformationsFailed.className = 'Vendd.Account.Messages.GetCouponInformationsFailed';
            
            Messages.InvalidateCouponCode = function (model) {
                var data = { couponCode: model.couponCode };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.InvalidateCouponCode', data);
            };
            Messages.InvalidateCouponCode.className = 'Vendd.Account.Messages.InvalidateCouponCode';

            Messages.InvalidateCouponCodeSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.InvalidateCouponCodeSuccess', data);
            };
            Messages.InvalidateCouponCodeSuccess.className = 'Vendd.Account.Messages.InvalidateCouponCodeSuccess';

            Messages.InvalidateCouponCodeFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.InvalidateCouponCodeFailed', response);
            };
            Messages.InvalidateCouponCodeFailed.className = 'Vendd.Account.Messages.InvalidateCouponCodeFailed';

            /*new message for entiry address info*/
            Messages.GetAddressInfo = function (fields, countryCode, prefecture, city, geoArea, streetNumberCombined, postalCode, pageSize, pageNumber) {
                var data = {
                    fields: fields,
                    countryCode: countryCode,
                    prefecture: prefecture,
                    city: city,
                    geoArea: geoArea,
                    postalCode: postalCode,
                    streetNumberCombined: streetNumberCombined,
                    pageSize: pageSize,
                    pageNumber: pageNumber
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressInfo', data);
            };
            Messages.GetAddressInfo.className = 'Vendd.Account.Messages.GetAddressInfo';

            Messages.GetAddressInfoSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressInfoSuccess', data);
            };
            Messages.GetAddressInfoSuccess.className = 'Vendd.Account.Messages.GetAddressInfoSuccess';

            Messages.GetAddressInfoFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressInfoFailed', response);
            };
            Messages.GetAddressInfoFailed.className = 'Vendd.Account.Messages.GetAddressInfoFailed';

            /* messages reffering to Request Return - start */
            Messages.ReloadEditControl = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ReloadEditControl', {});
            };
            Messages.ReloadEditControl.className = 'Vendd.Account.Messages.ReloadEditControl';

            Messages.ReloadEditControlSuccess = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ReloadEditControlSuccess', {});
            };
            Messages.ReloadEditControlSuccess.className = 'Vendd.Account.Messages.ReloadEditControlSuccess';

            Messages.ResetEditControl = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ResetEditControl', {});
            };
            Messages.ResetEditControl.className = 'Vendd.Account.Messages.ResetEditControl';

            Messages.ResetEditControlSuccess = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ResetEditControlSuccess', {});
            };
            Messages.ResetEditControlSuccess.className = 'Vendd.Account.Messages.ResetEditControlSuccess';

            Messages.ValidateEditControl = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ValidateEditControl', {});
            };
            Messages.ValidateEditControl.className = 'Vendd.Account.Messages.ValidateEditControl';

            Messages.ValidateEditControlSuccess = function (isValid, editAddressData) {
                var data = {
                    isValid: isValid,
                    editAddressData: editAddressData
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ValidateEditControlSuccess', data);
            };
            Messages.ValidateEditControlSuccess.className = 'Vendd.Account.Messages.ValidateEditControlSuccess';
            /* messages reffering to Request Return - end */

            /* Address groups */

            Messages.GetAddressGroups = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressGroups');
            };
            Messages.GetAddressGroups.className = "Vendd.Account.Messages.GetAddressGroups";

            Messages.GetAddressGroupsSuccess = function (response) {
                var data = {
                    model: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressGroupsSuccess', data);
            };
            Messages.GetAddressGroupsSuccess.className = 'Vendd.Account.Messages.GetAddressGroupsSuccess';

            Messages.GetAddressGroupsFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressGroupsFailed', response);
            };
            Messages.GetAddressGroupsFailed.className = 'Vendd.Account.Messages.GetAddressGroupsFailed';

            Messages.GetAddressGroup = function (addressGroupId) {
                var data = {
                    addressGroupId: addressGroupId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressGroup', data);
            };
            Messages.GetAddressGroup.className = "Vendd.Account.Messages.GetAddressGroup";

            Messages.GetAddressGroupSuccess = function (response) {
                var data = {
                    model: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressGroupSuccess', data);
            };
            Messages.GetAddressGroupSuccess.className = 'Vendd.Account.Messages.GetAddressGroupSuccess';

            Messages.GetAddressGroupFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressGroupFailed', response);
            };
            Messages.GetAddressGroupFailed.className = 'Vendd.Account.Messages.GetAddressGroupFailed';

            Messages.DeleteAddressGroup = function (addressGroupId) {
                var data = {
                    addressGroupId: addressGroupId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressGroup', data);
            };
            Messages.DeleteAddressGroup.className = "Vendd.Account.Messages.DeleteAddressGroup";

            Messages.DeleteAddressGroupSuccess = function (response) {
                var data = {
                    addressGroupId: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressGroupSuccess', data);
            };
            Messages.DeleteAddressGroupSuccess.className = 'Vendd.Account.Messages.DeleteAddressGroupSuccess';

            Messages.DeleteAddressGroupFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressGroupFailed', response);
            };
            Messages.DeleteAddressGroupFailed.className = 'Vendd.Account.Messages.DeleteAddressGroupFailed';

            Messages.EditAddressGroup = function (id, name, description) {
                var data = {
                    model: {
                        Id: id,
                        Name: name,
                        Description: description
                    }
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressGroup', data);
            };
            Messages.EditAddressGroup.className = "Vendd.Account.Messages.EditAddressGroup";

            Messages.EditAddressGroupSuccess = function (response) {
                var data = {
                    model: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressGroupSuccess', data);
            };
            Messages.EditAddressGroupSuccess.className = 'Vendd.Account.Messages.EditAddressGroupSuccess';

            Messages.EditAddressGroupFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressGroupFailed', response);
            };
            Messages.EditAddressGroupFailed.className = 'Vendd.Account.Messages.EditAddressGroupFailed';


            Messages.CheckAddressGroupIfExists = function (addressGroupId, name, description) {
                var data = {
                    model: {
                        Id: addressGroupId,
                        Name: name,
                        Description: description
                    }
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressGroupIfExists', data);
            };
            Messages.CheckAddressGroupIfExists.className = 'Vendd.Account.Messages.CheckAddressGroupIfExists';

            Messages.CheckAddressGroupIfExistsSuccess = function (response) {
                var data = {
                    model: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressGroupIfExistsSuccess', data);
            };
            Messages.CheckAddressGroupIfExistsSuccess.className = 'Vendd.Account.Messages.CheckAddressGroupIfExistsSuccess';

            Messages.CheckAddressGroupIfExistsFailure = function (response) {
                var data = {
                    model: response // Should be null / undefined.
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressGroupIfExistsFailure', data);
            };
            Messages.CheckAddressGroupIfExistsFailure.className = 'Vendd.Account.Messages.CheckAddressGroupIfExistsFailure';

            Messages.OpenAddressGroupEditForm = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.OpenAddressGroupEditForm', data);
            };
            Messages.OpenAddressGroupEditForm.className = 'Vendd.Account.Messages.OpenAddressGroupEditForm';

            Messages.AddressGroupModelChanged = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.AddressGroupModelChanged', response);
            };
            Messages.AddressGroupModelChanged.className = 'Vendd.Account.Messages.AddressGroupModelChanged';

            Messages.GetUserNotificationPreferences = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserNotificationPreferences');
            };
            Messages.GetUserNotificationPreferences.className = 'Vendd.Account.Messages.GetUserNotificationPreferences';

            Messages.GetUserNotificationPreferencesSuccess = function (response) {
                var data = response.data;

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserNotificationPreferencesSuccess', data);
            };
            Messages.GetUserNotificationPreferencesSuccess.className = 'Vendd.Account.Messages.GetUserNotificationPreferencesSuccess';

            Messages.GetUserNotificationPreferencesFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserNotificationPreferencesFailure', response);
            };
            Messages.GetUserNotificationPreferencesFailure.className = 'Vendd.Account.Messages.GetUserNotificationPreferencesFailure';

            Messages.SaveUserNotificationPreferences = function (model) {
                var data = {
                    userPreferences: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SaveUserNotificationPreferences', data);
            };
            Messages.SaveUserNotificationPreferences.className = 'Vendd.Account.Messages.SaveUserNotificationPreferences';

            Messages.SaveUserNotificationPreferencesSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SaveUserNotificationPreferencesSuccess', response);
            };
            Messages.SaveUserNotificationPreferencesSuccess.className = 'Vendd.Account.Messages.SaveUserNotificationPreferencesSuccess';

            Messages.SaveUserNotificationPreferencesFailure = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SaveUserNotificationPreferencesFailure', response);
            };
            Messages.SaveUserNotificationPreferencesFailure.className = 'Vendd.Account.Messages.SaveUserNotificationPreferencesFailure';


            return Messages;

        })(Account.Messages || {});

        return Account;

    })(Vendd.Account || {});

    return Vendd;

})(Vendd || {});